/**
 * @generated SignedSource<<bdbe96e667842a7abe86e000ca72fbe4>>
 * @relayHash 25e4d474a0e3bea819dc0312491c8ec1
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 25e4d474a0e3bea819dc0312491c8ec1

import { ConcreteRequest } from 'relay-runtime';
export type ContactChannel = "APP" | "EMAIL_AND_SMS" | "NO_CHANNEL";
export type Country = "CH" | "DE";
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type findChPatientByInternalIdQuery$variables = {
  internalId: number;
};
export type findChPatientByInternalIdQuery$data = {
  readonly ch_patientByInternalId: {
    readonly contactChannel: ContactChannel;
    readonly country: Country;
    readonly displayId: number;
    readonly duplicatePatients: ReadonlyArray<{
      readonly contactChannel: ContactChannel;
      readonly displayId: number;
      readonly firstName: string;
      readonly gender: Gender;
      readonly id: string;
      readonly lastName: string;
    }>;
    readonly firstName: string;
    readonly gender: Gender;
    readonly id: string;
    readonly lastName: string;
  } | null;
};
export type findChPatientByInternalIdQuery = {
  response: findChPatientByInternalIdQuery$data;
  variables: findChPatientByInternalIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "internalId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gender",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactChannel",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "patientInternalId",
        "variableName": "internalId"
      }
    ],
    "concreteType": "ch_Patient",
    "kind": "LinkedField",
    "name": "ch_patientByInternalId",
    "plural": false,
    "selections": [
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      (v6/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "country",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DuplicatePatientOutput",
        "kind": "LinkedField",
        "name": "duplicatePatients",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "findChPatientByInternalIdQuery",
    "selections": (v7/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "findChPatientByInternalIdQuery",
    "selections": (v7/*:: as any*/)
  },
  "params": {
    "id": "25e4d474a0e3bea819dc0312491c8ec1",
    "metadata": {},
    "name": "findChPatientByInternalIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "786d95758670385bf2b5dd231c3ea2c5";

export default node;
